import React from 'react';
import { Link } from 'react-router-dom';
import './banner.css';


const Banner = () => {
    return (
        <div className="banner">
            <div className="banner-text">
                <h1 className="banner-text-h1">Mari Berbagi</h1>
                <p className="banner-text-p">dengan mereka yang membutuhkan</p>
                <button className="banner-btn">
                    <Link to="/donasi-sekarang">
                        Donasi Sekarang
                    </Link>
                </button>
            </div>
        </div>
    )
}
export default Banner;